var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMmyEsmmy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4334_14724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.993 7.0293C19.993 7.0293 21.5038 7.12829 22.4239 7.6439C23.2216 8.09016 23.9982 9.11819 23.9982 9.11819C23.9982 9.11819 22.8585 9.47711 22.5038 9.89425C22.1782 10.2786 22.111 10.4527 22.111 10.4527C22.111 10.4527 21.2682 8.74657 19.75 8.1198L19.993 7.0293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20.1106C17 20.1106 17.7485 20.7665 18.4161 20.9576C18.9947 21.1207 19.8337 21.0042 19.8337 21.0042C19.8337 21.0042 19.4706 20.3075 19.4997 19.9486C19.5267 19.6183 19.5764 19.5061 19.5764 19.5061C18.9396 19.4182 18.3168 19.2481 17.7237 19L17 20.1106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21248 14.254C4.21248 14.254 3.0738 15.2524 2.05847 15.5394C1.17866 15.7871 -0.0976562 15.6098 -0.0976562 15.6098C-0.0976562 15.6098 0.455006 14.5494 0.412127 14.0042C0.370837 13.5023 0.295137 13.3314 0.295137 13.3314C0.295137 13.3314 2.09764 13.9422 3.61429 13.3118L4.21248 14.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55953 3.78131C8.55953 3.78131 7.71571 3.16301 7.37056 2.52088C7.07147 1.96504 7 1.07729 7 1.07729C7 1.07729 7.79776 1.28904 8.15932 1.17946C8.49177 1.07623 8.59552 1 8.59552 1C8.59552 1 8.45365 2.30702 9.10478 3.23553L8.55953 3.78131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12583 11C7.12583 11 6.63266 12.1856 7.59902 12.6587C8.56538 13.1319 10.9926 12.8928 10.9926 12.8928C10.9926 12.8928 8.88836 11.3417 7.12454 11H7.12583Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9822 12.0953C16.9822 12.0953 17.1559 13.0002 16.4076 13.1917C15.6593 13.3832 13.9883 12.8614 13.9883 12.8614C13.9883 12.8614 15.6936 12.0769 16.9822 12.0953Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4334_14724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmyEsmmy);
export default __webpack_public_path__ + "static/media/mmy_esmmy.4ee97b5b4cf3293b92fa4b5a4dc49cec.svg";
export { ForwardRef as ReactComponent };